import React, {useState} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Dropdown, Button, NumberField, TextField } from 'components'
import { FaPlus } from 'react-icons/fa'

const Container = styled.div`
    display: grid;
    grid-template-columns: auto 1fr 2rem;
    background-color: var(--primary-color);
    border-radius: 5px;
    padding: 0.2rem;
    /* display: flex;
    align-items: center; */
    /* display: grid;
    grid-template-columns: auto 1fr auto;
    grid-gap: 0.5rem;
    align-items: center;
    border: 1px solid red; */
`

const dayOptions = {
    days: 'Days',
    weeks: 'Weeks'
}

const timeOptions = {
    minutes: 'Minutes',
    hours: 'Hours',
    days: 'Days'
}

const CustomAlert = props => {
    const {
        type,
        onSubmit
    } = props;
    const options = type === 'day' ? dayOptions : timeOptions
    const [value, setValue] = useState(1)
    const [metric, setMetric] = useState(Object.keys(options)[0])

    return (
        <Container>
            <NumberField onChange={(v) => setValue(v)} value={value} max={999} min={1} style={{primaryColor: 'var(--primary-color)', secondaryColor: 'var(--secondary-color)', margin:0}}/>
            <Dropdown value={options[metric]} options={options} onSelect={(m) => setMetric(m)} style={{backgroundColor: 'var(--primary-color)', width: '100%', margin:0}}/>
            <Button icon={<FaPlus/>} iconOnly onSelect={() => onSubmit({value: value, metric: metric})} styles={{backgroundColor: 'var(--primary-color)', color: 'var(--text-color)', margin: 0}}/>
        </Container>
    )
}

export default CustomAlert

CustomAlert.propTypes = {
    type: PropTypes.oneOf(['day', 'time ']),
    onSubmit: PropTypes.func
}
